import React, { useState, useEffect, useRef } from "react";

import { Row, Col, Tab, Tabs, Form, Modal } from "react-bootstrap";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import { EmptyBlockText } from "./helper/const";
import { useUpdateStandardStatements } from "./hooks/useUpdateStandardStatements";
import Button from "components/common/Button/Button";

const styles = {
  btnWrapper: {
    flex: "0 0 10%",
  },
  priceInp: {
    flex: "0 0 12%",
  },
};

const StandardStatements = ({
  data,
  showPercentageStepperModal,
  updateFixedStandardStatementsPercentage,
}) => {
  const CATEGORIES = [
    "Standard Proposal Statements",
    "Warranty & Guarantee Statements",
  ];
  const [proposalOpening, setProposalOpening] = useState(null);
  const [standardStatements, setStandardStatements] = useState([]);
  const [warrantyStatements, setWarrantyStatements] = useState([]);
  const [priceStatements, setPriceStatements] = useState([]);
  const [multiLineStatements, setMultiLineStatements] = useState([]);
  const [Id, setId] = useState(0);

  useEffect(() => {
    if (data && data.length > 0) {
      const standardStatementInit = [];
      const warrantyStatementsInit = [];
      const priceStatementsInit = [];
      const multiLineStatementsInit = [];

      data.map((statement, i) => {
        if (statement.category === "") {
          setProposalOpening(statement);
        } else if (statement.category === CATEGORIES[0]) {
          standardStatementInit.push(statement);
        } else if (statement.category === CATEGORIES[1]) {
          if (statement.isMultiLine) {
            return multiLineStatementsInit.push(statement);
          }
          if (statement.label.includes("Price")) {
            return priceStatementsInit.push(statement);
          }
          warrantyStatementsInit.push(statement);
        }
        setId(i);
      });
      setStandardStatements(standardStatementInit);
      setWarrantyStatements(warrantyStatementsInit);
      setPriceStatements(priceStatementsInit);
      setMultiLineStatements(multiLineStatementsInit);
    }
  }, [data]);

  console.log("standardStatements", standardStatements);
  console.log("warrantyStatements", warrantyStatements);
  console.log("priceStatements", priceStatements);
  console.log("multiLineStatements", multiLineStatements);

  const CategoryTitle = ({ title }) => (
    <Row>
      <Col style={{ textAlign: "center", margin: "1em 0" }}>{title}</Col>
    </Row>
  );
  return (
    <>
      {proposalOpening && <LongTextInput detail={proposalOpening} />}
      <EmptyBlock />
      <CategoryTitle title={CATEGORIES[0]} />
      {standardStatements.map((statement) => (
        <LongTextInput key={statement._id} detail={statement} />
      ))}

      <CategoryTitle title={CATEGORIES[1]} />
      {warrantyStatements.map((statement) => (
        <LongTextInput key={statement._id} detail={statement} />
      ))}
      {multiLineStatements.map((statement) => (
        <LongMultiTextIput key={statement._id} detail={statement} />
      ))}
      <Row style={{ marginTop: "1em" }}>
        <Col style={styles.btnWrapper} />
        <Col>
          <Form.Label>Price:</Form.Label>
        </Col>
        <Col style={styles.btnWrapper} />
      </Row>
      {priceStatements.map((statement, idx) => (
        <LongTextInputWithPrice
          key={statement._id}
          detail={statement}
          idx={idx}
          showPercentageStepperModal={showPercentageStepperModal}
          updateFixedStandardStatementsPercentage={
            updateFixedStandardStatementsPercentage
          }
        />
      ))}
    </>
  );
};

const CommonBtnsAndTitles = ({
  children,
  edit,
  displayText,
  setEdit,
  detail,
  hasPrice,
  price,
  hideTitle = false,
  showPercentageStepperModal,
  idx,
}) => {
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(detail.isSelected);
  const { mutate: updateStandardStatementsMutation, isPending } =
    useUpdateStandardStatements();

  const onSuccess = () => {
    toast.success("Successfully updated the statement.");
    setEdit(false);
    setLoading(false);
  };

  const onError = (errMsg) => {
    toast.error(errMsg);
    setLoading(false);
  };

  const handleUpdate = (detail, postData, onSuccess, onError) => {
    updateStandardStatementsMutation(
      { id: detail._id, data: postData },
      {
        onSuccess,
        onError: (error) => onError(error.message),
      }
    );
  };

  const updateData = (include) => {
    setLoading(true);
    let postData = {
      isSelected: include === undefined ? isSelected : include,
      displayText,
    };
    postData = hasPrice ? { ...postData, price } : postData;
    handleUpdate(detail, postData, onSuccess, onError);
  };

  const includeOrExclude = (include) => {
    setIsSelected(include);
    updateData(include);
  };

  return (
    <>
      {!hideTitle ? (
        <Row style={{ marginTop: "1em" }}>
          <Col style={styles.btnWrapper} />
          <Col>
            <Form.Label>{detail.label}</Form.Label>
          </Col>
          <Col style={styles.btnWrapper} />
        </Row>
      ) : null}
      <Row>
        <Col style={styles.btnWrapper}>
          {isSelected ? (
            <Button
              variant="danger"
              disabled={loading || edit}
              onClick={() => {
                includeOrExclude(false);
              }}
            >
              Exclude
            </Button>
          ) : (
            <Button
              variant="success"
              disabled={loading || edit}
              onClick={() => {
                includeOrExclude(true);
              }}
            >
              Include
            </Button>
          )}
        </Col>
        <Col
          style={
            isSelected ? {} : { textDecoration: "line-through", color: "gray" }
          }
        >
          {children}
        </Col>
        <Col style={styles.btnWrapper}>
          {edit ? (
            <Button
              className="__btn_expanded"
              disabled={loading}
              variant="outline-success"
              onClick={() => updateData()}
              isLoading={loading}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          ) : (
            <Button
              className="__btn_expanded"
              variant="outline-secondary"
              disabled={loading}
              onClick={() => setEdit(true)}
            >
              Edit
            </Button>
          )}
        </Col>
        <Col style={styles.btnWrapper}>
          {edit ? (
            <Button
              className="__btn_expanded"
              variant="danger"
              disabled={loading}
              onClick={() => setEdit(false)}
            >
              Cancel
            </Button>
          ) : (
            detail.percentage !== undefined &&
            hasPrice && (
              <Button
                className="__btn_expanded"
                variant="outline-primary"
                style={{ fontSize: "0.9em" }}
                disabled={loading}
                onClick={() => showPercentageStepperModal(detail, idx)}
              >
                <span style={{ fontSize: "0.9em" }}>
                  Percentage {detail.percentage}%
                </span>
              </Button>
            )
          )}
        </Col>
      </Row>
    </>
  );
};

const LongTextInputWithPrice = ({
  detail,
  showPercentageStepperModal,
  idx,
  updateFixedStandardStatementsPercentage,
}) => {
  const [edit, setEdit] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [priceValue, setPriceValue] = useState(detail.price ? detail.price : 0);

  // Update text and price when detail changes
  useEffect(() => {
    setDisplayText(detail.displayText);

    if (detail.price !== undefined) {
      setPriceValue(
        !isNaN(detail.price)
          ? Number(detail.price).toFixed(2)
          : Number(0).toFixed(2)
      );
    }
  }, [detail.displayText, detail.percentage, detail.price]);

  const debounceChangePrice = useRef(
    debounce((value) => {
      if (!isNaN(value)) {
        setPriceValue(Number(value).toFixed(2));
      } else {
        if (Number(value) === 0) return;
        setPriceValue(Number(0).toFixed(2));
      }
    }, 1500)
  );

  const handleInputChange = (e) => {
    const value = e.target.value.replace("$", "");
    setPriceValue(value);
    debounceChangePrice.current(value);
  };

  return (
    <CommonBtnsAndTitles
      price={priceValue}
      hideTitle
      detail={detail}
      idx={idx}
      displayText={displayText}
      edit={edit}
      setEdit={setEdit}
      hasPrice={detail.price !== undefined}
      showPercentageStepperModal={showPercentageStepperModal}
    >
      <Row>
        <Col>
          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Control
              onChange={(e) => setDisplayText(e.target.value)}
              value={displayText}
              disabled={!edit}
              type="text"
              style={{ marginBottom: "15px" }}
            />
          </Form.Group>
        </Col>
        {detail.price !== undefined && (
          <Col style={styles.priceInp}>
            <Form.Group>
              <Form.Control
                disabled={!edit}
                type="text"
                value={`$${priceValue}`}
                style={{ textAlign: "right" }}
                onChange={(event) => handleInputChange(event)}
              />
            </Form.Group>
          </Col>
        )}
      </Row>
    </CommonBtnsAndTitles>
  );
};

const LongTextInput = ({ detail }) => {
  const [edit, setEdit] = useState(false);
  const [displayText, setDisplayText] = useState(detail.displayText);

  // Update text when detail changes
  useEffect(() => {
    setDisplayText(detail.displayText);
  }, [detail.displayText]);

  return (
    <CommonBtnsAndTitles
      detail={detail}
      displayText={displayText}
      edit={edit}
      setEdit={setEdit}
      hasPrice={false}
    >
      <Form.Group style={{ marginBottom: "15px" }}>
        <Form.Control
          onChange={(e) => setDisplayText(e.target.value)}
          value={displayText}
          disabled={!edit}
          type="text"
          style={{ marginBottom: "15px" }}
        />
      </Form.Group>
    </CommonBtnsAndTitles>
  );
};

const LongMultiTextIput = ({ detail }) => {
  const [edit, setEdit] = useState(false);
  const [displayText, setDisplayText] = useState(detail.displayText);

  // Update text when detail changes
  useEffect(() => {
    setDisplayText(detail.displayText);
  }, [detail.displayText]);

  return (
    <CommonBtnsAndTitles
      detail={detail}
      displayText={displayText}
      edit={edit}
      setEdit={setEdit}
      hasPrice={false}
    >
      <Form.Group style={{ marginBottom: "15px" }}>
        <Form.Control
          as="textarea"
          rows="3"
          style={{ resize: "none", marginBottom: "15px" }}
          value={displayText}
          disabled={!edit}
          onChange={(e) => setDisplayText(e.target.value)}
        />
      </Form.Group>
    </CommonBtnsAndTitles>
  );
};

function EmptyBlock() {
  return (
    <Row>
      <Col style={styles.btnWrapper} />
      <Col>
        <div className="__empty_block">
          <span dangerouslySetInnerHTML={{ __html: EmptyBlockText }} />
        </div>
      </Col>
      <Col style={styles.btnWrapper} />
    </Row>
  );
}

export default StandardStatements;
